import React from 'react';
import { FaUsers, FaCheckCircle, FaClock, FaSchool } from 'react-icons/fa';
import SurveyStatCard from './SurveyStatCard';
import SurveyProgressDonut from './SurveyProgressDonut';

const SurveyOverviewTab = ({ survey, summary, onNarrowToStudents }) => {
  const targeted = summary.targeted_students ?? 0;
  const completed = summary.completed_responses ?? 0;
  const completionRate = summary.completion_rate ?? 0;
  const pending = summary.pending ?? Math.max(targeted - completed, 0);

  return (
    <>
      <div className="row">
        <SurveyStatCard title="Targeted" value={targeted} subtext="non-suspended students" icon={<FaUsers />} />
        <SurveyStatCard title="Completed" value={completed} subtext="responses recorded" icon={<FaCheckCircle />} tone="success" />
        <SurveyStatCard title="Pending" value={pending} subtext="not yet submitted" icon={<FaClock />} tone="warning" />
        <SurveyStatCard title="Completion rate" value={`${completionRate}%`} subtext={`${completed} of ${targeted}`} icon={<FaSchool />} solid />
      </div>

      <div className="survey-detail-columns">
        <div className="card survey-panel">
          <div className="survey-panel-title">Targeting &amp; window</div>
          <div className="survey-panel-body">
            <div className="survey-detail-row">
              <div className="survey-detail-row-label">Classes</div>
              <div className="survey-detail-row-value">
                {(survey.programs || []).map((program, index) => (
                  <span
                    key={`${program.id ?? program.program_id ?? program.program?.id}-${index}`}
                    className="survey-meta-chip survey-chip-solid"
                  >
                    {program.name ?? program.program?.name}
                  </span>
                ))}
              </div>
            </div>

            <div className="survey-detail-row">
              <div className="survey-detail-row-label">Audience</div>
              <div className="survey-detail-row-value survey-detail-row-value-inline">
                <span className="survey-mode-chip">
                  <span className="survey-mode-chip-dot"></span>
                  <FaSchool /> {survey.is_student_specific ? 'Selected students' : 'Whole class'}
                </span>
                <button type="button" className="survey-inline-link" onClick={onNarrowToStudents}>
                  Narrow to students &rarr;
                </button>
              </div>
            </div>

            <div className="survey-detail-row">
              <div className="survey-detail-row-label">Available</div>
              <div className="survey-detail-row-value survey-detail-mono">
                {survey.start_date} {survey.start_time || '00:00:00'} &rarr; {survey.end_date} {survey.end_time || '23:59:59'}
              </div>
            </div>

            <div className="survey-detail-row">
              <div className="survey-detail-row-label">Identity</div>
              <div className="survey-detail-row-value">
                {survey.is_anonymous ? 'Anonymous — not linked to student identity' : 'Tagged with student id'}
              </div>
            </div>

            {survey.sm_collector_url && (
              <div className="survey-detail-row">
                <div className="survey-detail-row-label">Collector</div>
                <div className="survey-detail-row-value survey-detail-mono">{survey.sm_collector_url}</div>
              </div>
            )}
          </div>
        </div>

        <div className="card survey-panel">
          <div className="survey-panel-title">Progress</div>
          <div className="survey-panel-body survey-panel-body-center">
            <SurveyProgressDonut percent={completionRate} completed={completed} total={targeted} />
          </div>
        </div>
      </div>
    </>
  );
};

export default SurveyOverviewTab;
